import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

/*
 YES! This is a hack... but hopefully only until we find a better solution :)
 Wanted to access material colors without doing alot of configuration inside the original app.
*/

@Component({
  selector: 'colors-grabber',
  template: `
    <button #primary mat-flat-button color="primary"></button>
    <button #accent mat-flat-button color="accent"></button>
    <button #warn mat-flat-button color="warn"></button>
  `,
  styles: [':host { display: none; }']
})
export class ColorsGrabberComponent implements AfterViewInit {
  defaultPrimary = 'white';
  defaultAccent = 'white';
  defaultWarn = 'red';

  primary$: Observable<string> = new Observable(observer => {
    observer.next(this.defaultPrimary);
    this.setPrimary = (primary: string) => observer.next(primary);
  });
  accent$: Observable<string> = new Observable(observer => {
    observer.next(this.defaultAccent);
    this.setAccent = (accent: string) => observer.next(accent);
  });
  warn$: Observable<string> = new Observable(observer => {
    observer.next(this.defaultWarn);
    this.setWarn = (warn: string) => observer.next(warn);
  });

  @ViewChild('primary', { read: ElementRef, static: true }) private primaryElement!: ElementRef;
  @ViewChild('accent', { read: ElementRef, static: true }) private accentElement!: ElementRef;
  @ViewChild('warn', { read: ElementRef, static: true }) private warnElement!: ElementRef;

  setPrimary(primary: string) {
    this.defaultPrimary = primary;
  }
  setAccent(accent: string) {
    this.defaultAccent = accent;
  }
  setWarn(warn: string) {
    this.defaultWarn = warn;
  }

  ngAfterViewInit() {
    const primaryStyles: any = getComputedStyle(this.primaryElement.nativeElement) as any;
    this.setPrimary(primaryStyles['background-color'] as string);
    const accentStyles: any = getComputedStyle(this.accentElement.nativeElement) as any;
    this.setAccent(accentStyles['background-color'] as string);
    const warnStyles: any = getComputedStyle(this.warnElement.nativeElement) as any;
    this.setWarn(warnStyles['background-color'] as string);
  }
}
